// plop_marker:layouts_import
import MultiTemplatesTemplates from "./multi-templates-templates/index.js";
export default {
    // plop_marker:layouts_add_layout
    MultiTemplatesTemplates
};
